// import React from 'react'
import { connect } from 'react-redux'
import ViewChallengeComponent from 'viewchallenge/components/ViewChallengeComponent';
import * as selectors from 'app/selectors'
import { actions as viewchallengeapiAction } from '../../api/actions'
import moment from 'moment'

// Interfaces
interface StateToProps {
    viewchallengeSettings?: ChallengeSettingsDto,
    challengedata?: ViewChallengeDataRecord,
    ambassadorprofile?:ViewAmbassadorProfileRecord,
    daysRemaining?:string,
    fundedpercentage?:number,
    socialIcons?:string
    
}

export const mapDispatchToProps = (dispatch: any) => {
    const { startViewChallengeData,startViewAmbassadorProfile } = viewchallengeapiAction
    return {
        getChallenge: () => dispatch(startViewChallengeData()),
        getAmbassadorProfile: (ambassadorId: number) => dispatch(startViewAmbassadorProfile(ambassadorId)),
        dispatch
    }
}
let getPercentageFunded = (RaisedAmount: number, GoalAmount: number): number => {
    return Math.floor((RaisedAmount / GoalAmount) * 100);
}
let getDaysRemaining = (startDate: string): string => {
    if (moment(startDate).diff(moment(), 'day') <= 0)
        return "0 minutes"
    else
        return moment(startDate).diff(moment(), 'day').toString() + ' days';
  }
  

// connect the component to redux
export const mapStateToProps = (state: RootState): StateToProps => {
    const viewchallengeSettings = selectors.getInstanceSettings(state) as ChallengeSettingsDto | undefined
    const challengedata = state.viewchallenge && state.viewchallenge.challengeData
    const ambassadorprofile = state.viewchallenge && state.viewchallenge.ambassadorprofile

    const dayStart = challengedata && challengedata.ChallengeEndDate
    const daysRemaining = getDaysRemaining(String(dayStart))
    const challengetype  = challengedata && challengedata.ChallengeGoalType
    const raisedamount = challengedata && challengedata.RaisedAmount
    const goalamount = challengedata && challengedata.GoalAmount
    const numofdonation = challengedata && challengedata.NumberOfDonations
    const goalparticipation = challengedata && challengedata.GoalParticipation 
    const fundedpercentage =  challengetype!=="Participation"? getPercentageFunded(Number(raisedamount),Number(goalamount)) : getPercentageFunded(Number(numofdonation),Number(goalparticipation))   
    const socialIcons = challengedata && challengedata.socialIcons
    return {
        viewchallengeSettings,
        challengedata,
        ambassadorprofile,
        daysRemaining,
        fundedpercentage,
        socialIcons
    }
}
export const Viewchallenge = connect(mapStateToProps, mapDispatchToProps)(ViewChallengeComponent)
